import { createFetch } from '@vueuse/core';
import { computed, toValue } from 'vue';
import { MONO_API } from '@/config/appConfig';

const pagesFetch = createFetch({
  baseUrl: MONO_API,
  options: {
    async onFetchError(payload) {
      console.warn('onFetchError', payload);
      return payload;
    },
  },
});

export default () => ({
  /**
   * Get a page by ID.
   * @param {string|Ref<string>} pageId - The ID of the page to fetch.
   * @param {Object} options - Additional fetch options.
   * @returns {Promise<Object>} - The fetched page data.
   */
  getPage(pageId, options = {}) {
    const url = computed(() => (
      MONO_API.indexOf('local.tagboard') === -1
        ? `public/pages/${toValue(pageId)}`
        : `/pages/${toValue(pageId)}?status=published`
    ));

    return pagesFetch(url, options).get().json();
  },

  /**
   * Get a page preview (a la draft) by ID.
   * @param {string|Ref<string>} pageId - The ID of the page to fetch.
   * @param {Object} options - Additional fetch options.
   * @returns {Promise<Object>} - The fetched page preview data.
   */
  getPagePreview(pageId, options = {}) {
    const url = computed(() => `pages/${toValue(pageId)}?status=draft&ts=${Date.now()}`);
    return pagesFetch(url, options).get().json();
  },
});
